<template>
  <div
    :class="[
      {
        'oap-card-list oap-card-list--layout-grid':
          gridDataset.gridType === 'ProductsList' ||
          gridDataset.gridType === 'ProductsListTwoColumns' ||
          gridDataset.gridType === 'ArticlesListTwoColumns',
      },
      {
        'filterGrid -articlesGrid': gridDataset.gridType === 'ArticlesList',
      },
      {
        'filterGrid -articlesGrid':
          gridDataset.gridType === 'ArticlesListTwoColumns' &&
          gridDataset.cardType === 'ArticleCard',
      },
      { 'filterGrid -ingredientsGrid': gridDataset.gridType === 'IngredientsList' },
    ]"
  >
    <template
      v-if="
        gridDataset.gridType === 'ProductsList' || gridDataset.gridType === 'ProductsListTwoColumns'
      "
    >
      <!-- OAP Non-Product Cards -->
      <template v-for="card in nonProductCardsList">
        <template v-if="card.type === 'promoCard'">
          <OapPromoCard
            v-if="hasPromoCards"
            :key="card.id"
            :position="card.position"
            :item="card.promoCard"
          ></OapPromoCard>
        </template>
        <template v-else-if="card.type === 'bgCard'">
          <OapBeautyGeniusCard
            :key="card.id"
            :position="card.position"
            :item="card.bgCard"
          ></OapBeautyGeniusCard>
        </template>
      </template>

      <!-- OAP Product Cards -->
      <OapCard
        v-for="(item, index) in itemsCollection"
        :key="`productList_` + index + `_` + item.id"
        :display-review-count="displayReviewCount"
        :item="item"
        :layouts="productGridLayouts"
        :productsfull-search-result="productsfullSearchResult"
        :position-on-grid="getPositionOnGridWithPromoCards(index)"
        :promo-card-items="nonProductCardsList"
        :wishlist-img="wishlistImg"
        :unwishlist-img="unwishlistImg"
        :wishlist-alt="wishlistAlt"
        :unwishlist-alt="unwishlistAlt"
        :is-wishlist-enabled="isProductWishlistEnabled"
      >
      </OapCard>
    </template>

    <template
      v-if="
        gridDataset.gridType === 'ArticlesList' ||
        (gridDataset.gridType === 'ArticlesListTwoColumns' &&
          gridDataset.cardType === 'ArticleCard')
      "
    >
      <div class="filterGrid__itemsWrapper" data-tag-wrapper>
        <template v-for="(bgCard, index) in nonProductCardsList">
          <template
            v-if="bgCard.type === 'bgCard' && gridListLength + 1 + index - bgCard.position >= 0"
          >
            <OapBeautyGeniusCardExpandedInGrid
              :key="bgCard.id"
              :position="bgCard.position"
              :item="bgCard.bgCard"
            ></OapBeautyGeniusCardExpandedInGrid>
          </template>
        </template>

        <article
          v-for="(item, index) in gridDataset.list"
          :key="index"
          class="filterGrid__item"
          :style="{ order: getPositionOnGridWithBGCards(index) }"
        >
          <ArticleCard
            :item="item"
            :wishlist-img="wishlistImg"
            :unwishlist-img="unwishlistImg"
            :wishlist-alt="wishlistAlt"
            :unwishlist-alt="unwishlistAlt"
            :is-wishlist-enabled="isArticleWishlistEnabled"
          >
          </ArticleCard>
        </article>
      </div>
    </template>

    <template
      v-if="
        gridDataset.gridType === 'ArticlesListTwoColumns' &&
        gridDataset.cardType === 'ArticleCardSearch'
      "
    >
      <article
        v-for="(item, index) in gridDataset.list"
        :key="index"
        v-tag:articleimpression="{
          event_name: 'view_promotion',
          promotions: [
            {
              id: 'article',
              name: item.itemResult.title,
              creative: 'article',
              position: item.position,
            },
          ],
        }"
        data-tag-wrapper
        class="oap-card oap-card--type-content"
      >
        <div class="oap-card__thumbnail">
          <img
            :src="item.itemResult.image.src"
            :alt="item.itemResult.image.alt"
            :aria-hidden="true"
          />
        </div>
        <header>
          <h3 class="oap-card__heading">
            <a
              v-tag:useractionevent="{
                category: 'search results page',
                action: 'select::article',
                label: item.itemResult.title,
                module_name: 'article list',
                cta_name: item.itemResult.title,
                link_url: `${urlOrigin}${item.url}`,
                article_name: item.itemResult.title,
                event_name: 'body_button_click',
              }"
              class="oap-card__link"
              :href="item.url"
              :aria-label="generateAriaLabel(item.itemResult.title, item.itemResult.label)"
            >
              <span class="oap-card__title">{{ item.itemResult.title }}</span>
            </a>
          </h3>
        </header>
      </article>
    </template>

    <template v-if="gridDataset.gridType === 'IngredientsList'">
      <div class="filterGrid__itemsWrapper" data-tag-wrapper>
        <article v-for="(item, index) in gridDataset.list" :key="index" class="filterGrid__item">
          <div class="ingredientTile">
            <div class="ingredientTile__wrapper">
              <div class="ingredientTile__imageWrapper">
                <img
                  class="lazyload"
                  src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                  :data-src="item.itemResult.image.fileName"
                  :alt="item.itemResult.image.alt"
                  :aria-hidden="true"
                />
              </div>
              <div class="ingredientTile__infoWrapper">
                <p class="ingredientTile__title" role="heading" aria-level="2">
                  <a
                    v-tag:useractionevent="{
                      category: 'product ingredients',
                      action: 'select::ingredient',
                      label: item.itemResult.title,
                    }"
                    :href="item.url"
                  >
                    {{ item.itemResult.title }}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </article>
      </div>
    </template>
  </div>
</template>

<script>
import OapCard from './../../../../OapCard/code/Scripts/components/OapCard.vue';
import OapPromoCard from './../../../../OapPromoCard/code/Scripts/components/OapPromoCard.vue';
import OapBeautyGeniusCard from '@Feature/OapBeautyGeniusCard/code/Scripts/components/OapBeautyGeniusCard.vue';
import OapBeautyGeniusCardExpandedInGrid from '@Feature/OapBeautyGeniusCard/code/Scripts/components/OapBeautyGeniusCardExpandedInGrid.vue';
import { mapState } from 'vuex';
import { AnalyticsHandler } from '@Foundation';
import eventBus from '@loreal/eventbus-js';
import { imageloaded } from '@Foundation/directives/imageloaded/imageloaded';
import { tag } from '@Foundation/analyticsHandler/directives/tag';
import { productItemToProductCardMapper } from '@Foundation/mappers/productItemToProductCardMapper';
import ArticleCard from './ArticleCard.vue';

export default {
  name: 'Grid',

  components: {
    OapCard,
    OapPromoCard,
    OapBeautyGeniusCard,
    OapBeautyGeniusCardExpandedInGrid,
    ArticleCard,
  },

  directives: {
    imageloaded,
    tag,
  },

  props: {
    displayReviewCount: {
      default: false,
      type: Boolean,
    },

    gridDataset: {
      type: Object,
      required: true,
    },

    productsfullSearchResult: {
      type: Boolean,
      default: false,
    },
    wishlistImg: {
      type: String,
      default: '',
    },
    unwishlistImg: {
      type: String,
      default: '',
    },
    wishlistAlt: {
      type: String,
      default: '',
    },
    unwishlistAlt: {
      type: String,
      default: '',
    },
    isArticleWishlistEnabled: {
      type: Boolean,
      default: false,
    },
    isProductWishlistEnabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      itemsArticle: [],
      allitemsArticle: [],
      ratings: 5,
      incrementer: 1,
    };
  },

  computed: {
    ...mapState('filterList', ['loading', 'lazyImages', 'likeHidden', 'isLayoutSearchPage']),

    // todo: Next 2 computed are temporary workaround until BE can process data at controller level
    productGridLayouts() {
      const layoutsArray = ['in-grid'];

      if (this.gridDataset.list.some((item) => item.itemResult.colors))
        layoutsArray.push('with-shades');

      return layoutsArray;
    },

    itemsCollection() {
      const mapper = (item) =>
        productItemToProductCardMapper(item, this.gridDataset, this.isLayoutSearchPage);

      return this.gridDataset.gridType === 'ProductsList' ||
        this.gridDataset.gridType === 'ProductsListTwoColumns'
        ? this.gridDataset.list.map(mapper)
        : null;
    },

    gridListLength() {
      return this.gridDataset.list.length;
    },

    nonProductCardsList() {
      return this.gridDataset.nonProductCardsList;
    },

    hasPromoCards() {
      return this.nonProductCardsList && this.nonProductCardsList.length !== 0;
    },

    // TODO: Remove when implementing a new articles grid
    urlOrigin() {
      return window.location.origin;
    },
  },

  mounted() {
    /* istanbul ignore next */
    eventBus.on('focus::gridElement', (elementCount) => {
      let interval = false;
      interval = setInterval(() => {
        if (!this.loading) {
          document.querySelectorAll('.filterGrid__tileLink')[elementCount].focus();
          clearInterval(interval);
        }
      }, 200);
    });

    var articlelikeval = document.getElementById('articlelikesetting')?.value;

    if (articlelikeval == 'True') {
      var hideableSections = document.getElementById('filterList');
      hideableSections.classList.add('active_likecontainer');

      var allAricles = document.querySelectorAll('.like__btn');

      for (var i = 0; i < allAricles.length; i++) {
        let allarticleIds = allAricles[i].getAttribute('id');
        this.allitemsArticle.push(allarticleIds);
      }

      var articlelike = JSON.parse(localStorage.getItem('articlelike'));
      var numberOfChildren = articlelike && articlelike.length;
      if (numberOfChildren > 0) {
        for (let i = 0; i < articlelike.length; i++) {
          for (var j = 0; j < allAricles.length; j++) {
            let allarticleIds = allAricles[j].getAttribute('id');
            var currentItem = articlelike[i];
            if (allarticleIds == currentItem) {
              document.getElementById(articlelike[i]).classList.add('active_like');
            }
          }
          this.itemsArticle.push(articlelike[i]);
        }
      }

      fetch(`/api/sitecore/article/GetLikeCountList?&idList=${this.allitemsArticle}`)
        .then((response) => response.json())
        .then((jsonData) => {
          var hideableSections = document.querySelectorAll('.like__btn');
          for (var i = 0; i < hideableSections.length; i++) {
            var allarticleIds = hideableSections[i].getAttribute('id');
            if (jsonData.list[i].likeCount <= 0) {
              document
                .getElementById(allarticleIds)
                .getElementsByClassName('like__number')[0].innerHTML = '';
            } else {
              document
                .getElementById(allarticleIds)
                .getElementsByClassName('like__number')[0].innerHTML = jsonData.list[i].likeCount;
            }
          }
        })
        .catch((e) => console.error(e));
    }
  },
  methods: {
    getPositionOnGridWithPromoCards(index) {
      const indexer = Number.parseInt(index);
      if (index === 0) return 2;
      if (index < 5) return indexer + 2;
      if (index >= 5) return indexer + 3;
    },

    // specific for article page
    getPositionOnGridWithBGCards(index) {
      const bgCardPosition = Math.floor(index / 4);

      return index + 1 + bgCardPosition;
    },

    // TODO: Remove when implementing a new articles grid
    generateAriaLabel(title, label) {
      let generateAriaLabel;
      if (title || label) {
        generateAriaLabel = `${title || ''} ${label ? `(${label})` : ''}`;
      } else {
        generateAriaLabel = false;
      }
      return generateAriaLabel;
    },

    likecounters: function (likeCount, itemid) {
      var activeId = document.getElementById(itemid);

      if (activeId.classList.contains('active_like')) {
        likeCount = activeId.getElementsByClassName('like__number')[0].innerHTML;
        likeCount--;
        activeId.classList.remove('active_like');
        activeId.getElementsByClassName('like__number')[0].innerHTML = likeCount;
        fetch(`/api/sitecore/article/UpdateLikeCount?operatorValue=-1&itemID=${itemid}`)
          .then((response) => response.json())
          .catch((e) => console.error(e));
      } else {
        likeCount = activeId.getElementsByClassName('like__number')[0].innerHTML;
        likeCount++;
        activeId.classList.add('active_like');
        activeId.getElementsByClassName('like__number')[0].innerHTML = likeCount;
        fetch(`/api/sitecore/article/UpdateLikeCount?operatorValue=1&itemID=${itemid}`)
          .then((response) => response.json())
          .catch((e) => console.error(e));
      }
    },

    likecache(itemid) {
      var activeId = document.getElementById(itemid);

      if (activeId.classList.contains('active_like')) {
        this.itemsArticle.push(itemid);
      } else {
        const index = this.itemsArticle.indexOf(itemid);
        if (index > -1) {
          this.itemsArticle.splice(index, 1);
        }
      }
      localStorage.setItem('articlelike', JSON.stringify(this.itemsArticle));
    },

    getTaggingInfo(articletitle, likeCount, itemid) {
      var activeId = document.getElementById(itemid);
      likeCount = activeId.getElementsByClassName('like__number')[0].innerHTML;

      if (activeId.classList.contains('active_like')) {
        likeCount++;
        AnalyticsHandler.getAnalyticsHandler().push({
          type: 'userActionEvent',
          ecommerce: 'undefined',
          category: 'content page',
          action: 'like::article',
          label: articletitle + likeCount,
        });
      } else {
        likeCount--;
        AnalyticsHandler.getAnalyticsHandler().push({
          type: 'userActionEvent',
          ecommerce: 'undefined',
          category: 'content page',
          action: 'unlike::article',
          label: articletitle + likeCount,
        });
      }
    },
  },
};
</script>
